'use client';

import { useRef } from 'react';

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

/** An additive calculator keeps its form on screen, so Calculate changes nothing above the fold. */
export const useResultScroll = () => {
  const resultsRef = useRef<HTMLDivElement>(null);

  /** Deferred a frame: the panel mounts in the same commit, so the node is not yet in the document. */
  const scrollToResults = () => {
    requestAnimationFrame(() => {
      resultsRef.current?.scrollIntoView?.({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  };

  return { resultsRef, scrollToResults };
};
